import AppService from '../services/app.service';

const version = localStorage.getItem('app-version');

const initialState = { version: version}

export const app = {
  namespaced: true,
  state: initialState,
  actions: {
    getVersion({ commit }, version) {
      console.log(version)
      AppService.getVersion().then(
          appVersion => {
              commit('appVersion', appVersion);
          });
    }
  },
  mutations: {
    appVersion(state, version) {
        console.log('module1' + version)

      state.version = version;
    }
  }
};
